import CustomColumns from './svgs/CustomColumns.svg';
import CustomColumnsNew from './svgs/customColumnNew.svg?component';

import Email from './svgs/email.svg';
import EmailIconNew from './svgs/email-icon-new.svg';
import EmailBlack from './svgs/email_black.svg';
import CampaginSuccessSvg from './svgs/campaignSuccessIcon.svg';
import RejectCross from './svgs/reject.svg?component';
import languageIcon from './svgs/language-icon.svg';
import Sms from './svgs/sms.svg';
import TickIcon from './svgs/tick-icon.svg';
import CrossIcon from './svgs/cross-icon.svg';
import CloseCrossIcon from './svgs/closeCrossIcon.svg';
import CrossIconComponent from './svgs/closeCrossIcon.svg?component';
import SuccessTick from './svgs/success-tick.svg';
import CheckIconBlack from './svgs/checkIcon.svg';
import CheckIconBlue from './svgs/check-blue-icon.svg';
import KebabMenuIcon from './svgs/kabab-menu-icon.svg';
import KebabMenuIconFC from './svgs/kabab-menu-icon.svg?component';
import CheckBoxGreenSVG from './svgs/checkboxGreen.svg';
import CheckBoxBlueSVG from './svgs/checkboxBlue.svg';
import EyeSvg from './svgs/Union.svg';
import blackEyeSvg from './svgs/blackEye.svg';
import EyeIconNew from './svgs/view-product-icon.svg';
import ChechBoxGreySVG from './svgs/checkboxGrey.svg';
import Notification from './svgs/Notification.svg?component';
import NotificationNewIcon from './svgs/NotificationNewIcon.svg?component';
import CartNewIcon from './svgs/CartNewIcon.svg?component';
import DeactivateIcon from './svgs/deactivate.svg?component';
import ExecuteIcon from './svgs/execute.svg?component';
import PhotoIcon from './svgs/photo.svg';
import PhotoIconNew from './svgs/Photo_Icon_New.svg';
import PlusIconBlack from './svgs/plusIconBlack.svg';
import CaretDownIcon from './svgs/carretDownIcon.svg';
import CaretRightIcon from './svgs/caretRight.svg';
import DocIcon from './svgs/doc-icon.svg';
import DocIconComp from './svgs/doc-icon.svg?component';
import UploadIcon from './svgs/upload-icon.svg';
import DeleteIcon from './svgs/delete-icon.svg?component';
import SuspendAccessIcon from './svgs/SuspendAccessIcon.svg?component';
import SmallDeleteIcon from './svgs/small-delete-icon.svg';
import CreateIcon from './svgs/createIcon.svg';
import WarningIcon from './svgs/warning.svg';
import WarningIconNew from './pngs/warning-icon.png';
import CloseIcon from './svgs/closeIcon.svg?component';
import CloseRedIcon from './svgs/Close_Red_Icon.svg?component';
import CloseIconOutline from './svgs/cross-icon.svg';
import CopyIcon from './svgs/copy.svg';
import Verified from './svgs/verified.svg';
import UploadFile from './svgs/upload_file.svg?component';
import ZonoDigitalBgLogo from './svgs/zono_bg_logo.svg';
import DTERP from './svgs/dterp.svg';
import SearchProperty from './svgs/search_property.svg?component';
import Bot from './svgs/bot.svg';
import ViewDetailsIcon from './svgs/view-details-icon.svg';
import InviteLinkIcon from './svgs/invite-link-icon.svg';
import InviteLinkIconComponent from './svgs/invite-link-icon.svg?component';
import MoveChannelIcon from './svgs/move-channel-icon.svg';
import CheckBoxDefault from './svgs/DefaultCheck.svg';
import Neutral from './svgs/Neutral.svg';
import WarningSymbol from './svgs/warning.svg';
import HoverActive from './svgs/HoverActive.svg';
import Default from './svgs/Default.svg';
import DetailsGreen from './svgs/DetailsGreen.svg';
import Details from './svgs/Details.svg';
import CommsSearchIcon from './svgs/commsSearchIcon.svg';
import IssuesTabIcon from './svgs/issuesTabIcon.svg';
import GroupTabIcon from './svgs/groupsTabIcon.svg';
import GroupTabIconComponent from './svgs/groups-tab-icon.svg?component';
import CustomersTabIcon from './svgs/customersTabIcon.svg';
import CustomersTabIconComponent from './svgs/customersTabIcon.svg?component';
import FacebookGreyIcon from './svgs/facebook-grey.svg';
import FormGreyIcon from './svgs/form-icon-grey.svg';
import MobileGreyIcon from './svgs/mobile-icon-grey.svg';
import WhatsAppIcon from './svgs/whatsapp-icon.svg';
import CheckBoxZonoBlue from './svgs/Checked.svg';
import CheckBoxBlack from './svgs/checkboxBlack.svg';
import LedgerListIcon from './svgs/side-drawer-ledger-list-icon.svg';
import SortIcon from './svgs/sort.svg';
import CrossIconGrey from './svgs/cross-icon-grey.svg';
import TextColor from './svgs/textColor.svg';
import AlignCenter from './svgs/alignCenter.svg';
import AlignLeft from './svgs/alignLeft.svg';
import AlignRight from './svgs/alignRight.svg';
import BoldText from './svgs/boldText.svg';
import ItalicText from './svgs/italicText.svg';
import UnderLineText from './svgs/underlineText.svg';
import ListItemsIcon from './svgs/listItems.svg';
import IndentaionIcon from './svgs/indentation.svg';
import StrikeThrough from './svgs/strikeThrough.svg';
import DocumentColour from './svgs/documentColours.svg';
import DefaultColour from './svgs/defaultColors.svg';
import Popular from './svgs/popular.svg';
import MinusComponent from './svgs/minus.svg?component';
import PromotionPurple from './svgs/promotionPurple.svg?component';
import PromotionPurplePath from './svgs/promotionPurple.svg';
import AddButton from './svgs/addButton.svg';
import Resize from './svgs/resize.svg';
import WhatsApp from './svgs/whatsapp-grey.svg';
import WhatsAppIconComponent from './svgs/whatsapp-grey.svg?component';
import Instagram from './svgs/instagram.svg';
import Youtube from './svgs/youtube.svg';
import Facebook from './svgs/facebook.svg';
import Camera from './svgs/camera.svg';
import BusinessCard from './svgs/businessCard.svg';
import Document from './svgs/document.svg';
import Star from './svgs/star.svg';
import Media from './svgs/media.svg';
import Invoice from './svgs/invoice.svg';
import OrderComp from './svgs/order.svg?component';
import Order from './svgs/order.svg';
import CampaignNewIcon from './svgs/CampaignNewIcon.svg';
import FinanaceNewIcon from './svgs/FinanaceNewIcon.svg';
import Payment from './svgs/payment.svg';
import Message from './svgs/message.svg';
import Minus from './svgs/minus.svg';
import AddMember from './svgs/add-member.svg?component';
import UserCheckIcon from './svgs/User_Check.svg?component';
import Info from './svgs/info.svg';
import InfoIconButton from './svgs/info.svg?component';
import ListViewNew from './svgs/info.svg?component';
import CalendarIconComponent from './svgs/calendarIcon.svg?component';
import InputInfo from './svgs/InputInfo.svg';
import InputInfoError from './svgs/InputInfo_error.svg';
import Spinner from './svgs/Spinner3.svg';
import LockIconNew from './svgs/Lock-Icon.svg';
import UnLockIconNew from './svgs/Unlock-Icon.svg';
import MapIconNew from './svgs/MapIcon.svg';
import InvoiceNewIcon from './svgs/invoiceNewIcon.svg';
import OrderNewIcon from './svgs/OrderNewIcon.svg';
import OrderIconNew from './svgs/Order-Icon-New.svg';
import PaymentIconNew from './svgs/payment-Icon-New.svg';
import InvoiceIconNew from './svgs/invoice-Icon-New.svg';
import MediaIconNew from './svgs/Media-Icon-New.svg';
import MapIcon from './svgs/map-icon.svg';
import LockNewIcon from './svgs/LockIcon_new.svg';
import UnLockNewIcon from './svgs/UnlockIcon_new.svg';
import WhatsAppDisableIcon from './svgs/WhatsApp_disabled.svg';
import InviteIcon from './svgs/Invite.svg';
import ReInviteIcon from './svgs/Re_Invite.svg';
import InviteSentIcon from './svgs/Clock.svg';
import ClockBlackIcon from './svgs/clock-black.svg';

import ArrowRight from './svgs/arrow-right.svg';
import ArrowLeft from './svgs/arrow-left.svg';
import ArrowLeftNew from './svgs/arrow-left-new.svg';
import ArrowLeftFC from './svgs/arrow-left.svg?component';
import ArrowDown from './svgs/arrow-up.svg';
import ArrowPointer from './svgs/arrow-pointer.svg';

import AdminIcon from './svgs/AdminIcon.svg';
import MemberIcon from './svgs/MemberIcon.svg';
import MemberIconComponent from './svgs/MemberIcon.svg?component';
import OrderManagerIcon from './svgs/OrderManagerIcon.svg';
import OrderOperatorIcon from './svgs/OrderOperatorIcon.svg';
import CatalogueManagerIcon from './svgs/CatalogueManagerIcon.svg';
import FinanceManagerIcon from './svgs/FinanceManagerIcon.svg';
import CRMUserIcon from './svgs/CRMUserIcon.svg';
import AlgorithmIcon from './svgs/Algorithm-icon.svg';
import AlgorithmIconComponent from './svgs/Algorithm-icon.svg?component';

import ArrowUp from './svgs/arrow-down.svg';
import SelectArrowDown from './svgs/select_arrow_down.svg';
import SelectArrowUp from './svgs/select_arrow_up.svg';
import BlueArrowDown from './svgs/arrow_down.svg';
import WarningIconComponent from './svgs/warning-icon.svg?component';
import Warning from './svgs/warning-icon.svg';
import AddCircle from './svgs/add-circle.svg';
import AddCircleComp from './svgs/add-circle.svg?component';

import UncheckedBox from './svgs/unchecked_checkbox.svg';
import CheckedBox from './svgs/Checked_Checkbox.svg';
import CheckBoxDisable from './svgs/check-box-disable.svg';
import CalendarIcon from './svgs/calendarIcon.svg';
import CalendarNewIcon from './svgs/Calendar-new-Icon.svg';
import CalendarRoundCorners from './svgs/calendar.svg?component';
import TrashIcon from './svgs/trash_can.svg';
import TrashIconNew from './svgs/TrashNewIcon.svg';
import DeleteIconNew from './svgs/deleteIcon_New.svg';
import DeleteIconNewComp from './svgs/deleteIcon_New.svg?component';
import EditIcon from './svgs/edit-icon.svg?component';
import EditIconNew from './svgs/editIcon_New.svg?component';
import EditNewIconBlack from './svgs/edit-icon.svg?component';
import CalendarFaded from './svgs/calender-faded.svg';
import Calender from './svgs/calendar.svg';
import LockIcon from './svgs/lock.svg';
import DownIcon from './svgs/down-icon.svg';
import DownIconComponent from './svgs/down-icon.svg?component';
import UpIcon from './svgs/up-icon.svg';
import UpIconComponent from './svgs/up-icon.svg?component';
import Plus from './svgs/plus.svg';
import TrendingUp from './svgs/trending-up.svg';
import Download from './svgs/Download.svg';
import DownloadComponent from './svgs/Download.svg?component';
import New from './svgs/New.svg';
import offer from './svgs/offer.svg';
import offerIcon from './svgs/offer.svg?component';
import offerIconStr from './svgs/offer.svg';
import Special from './svgs/Special.svg';
import Folder from './svgs/folder.svg';
import NoProducts from './svgs/NoProducts.svg';
import ZotokLogo from './svgs/ZoTok_Logo.svg';
import ZotokCircle from './svgs/ZotokCircle.svg';
import PlusIcon from './svgs/plusIcon.svg';
import DiscountIcon from './svgs/discountIcon.svg';
import FilterNew from './svgs/FilterNew.svg?component';
import ZoaiIcon from './svgs/ZOAI_Icon.svg?component';
import SearchNew from './svgs/search-new.svg';
import NoSearchResults from './svgs/NoSearchResults.svg';
import AssignTeamMember from './svgs/assign-team-member.svg';
import AssignTeamMember_ from './svgs/assign-team-member.svg?component';
import InfoIcon from './svgs/info-icon.svg';
import InfoGrey from './svgs/info-grey.svg';
import IrrelevantIcon from './svgs/Irrelevant-Icon.svg';
import KebabMenuIcon2 from './svgs/Kebab-menu-icon.svg?component';
import kebabMenuBlueIcon from './svgs/kebabMenuBlueIcon.svg';
import kebabMenuBlueNewIcon from './svgs/Kebab_menu_Blue_newIcon1.svg';
import InvoiceIcon from './svgs/invoices-icon.svg';
import OrderIcon from './svgs/orders-icon.svg';
import orderTagIcon from './svgs/orderTag-icon.svg';
import TagIcon from './svgs/orderTag-icon.svg?component';
import iconInfo from './svgs/icon-info.svg';
import InfoIconBlue from './svgs/info_icon_blue.svg';
import Rupee from './svgs/rupee.svg';
import ColumnIcon from './svgs/column-icon.svg';
import Rename from './svgs/rename.svg';

import CloseBlueIcon from './svgs/close_blue.svg';
import CloseWhiteIcon from './svgs/close_white.svg';
import CloseCross from './svgs/close.svg?component';
import ChecklistCloseComp from './svgs/checklist-close.svg?component';
import AddIconComponent from './svgs/addIconComponent.svg?component';
import CloseGrey from './svgs/closeGrey.svg?component';
import searchIcon from './svgs/search-icon.svg';
import searchIconComponent from './svgs/search-icon.svg?component';
import detailsBlue from './svgs/detailsBlue.svg?component';
import otherInfoBlue from './svgs/otherInfoBlue.svg?component';
import DefaultSize from './pngs/default-size.png';
import AcceptTick from './svgs/acceptTick.svg';
import Location from './svgs/location-pin.svg';
import LocationNewIcon from './svgs/location-new-icon.svg';
import CfaLocationNewIcon from './svgs/CFA-location-icon.svg';
import PhoneIcon from './svgs/phone-icon.svg?component';
import UserIcon from './svgs/user-icon.svg';
import UserIconDynamic from './svgs/user-icon.svg?component';
import UserNewIcon from './svgs/User-new-icon.svg';
import UserBlackIcon from './svgs/user-black.svg';
import PhoneBlackIcon from './svgs/phone-black-icon.svg';
import UploadFileIcon from './svgs/upload-file.svg';
import LeftArrow from './svgs/left-arrow.svg';
import LeftArrowNew from './svgs/left_arrow_new.svg';
import RightArrowNew from './svgs/right_arrow_new.svg';
import MinusIcon from './svgs/minus-icon.svg';
import IconPlus from './svgs/plus-icon.svg';
import IconPlusComponent from './svgs/plus-icon.svg?component';
import CloseBlueRound from './svgs/CloseBlueRound.svg';
import ReturnIcon from './svgs/return.svg';
import ZotokIcon from './svgs/brand-logos/zotok.svg';
import DownloadIcon from './svgs/icon-download.svg';
import DocumentIcon from './svgs/document-icon.svg';
import DocumentGreyIcon from './svgs/document-grey.svg';
import TrendingDown from './svgs/trending-down.svg';
import ScheduleIcon from './svgs/schedule.svg';
import SchedulerIcon from './svgs/scheduler.svg?component';
import AddCircleBlueOutlinedComp from './svgs/add-circle-blue-outlined.svg?component';
import DownloadHistoryIcon from './svgs/download-history-icon.svg?component';
import Assets from './svgs/assets.svg';
import Weight from './svgs/weight.svg';
import Truck from './svgs/truck.svg';
import Steering from './svgs/steering.svg';
import DriverIcon from './svgs/driver.svg';
import City from './svgs/city.svg';
import Pincode from './svgs/pincode.svg';
import UploadIconBlue from './svgs/upload-icon-blue.svg';
import DownloadBlue from './svgs/download-blue.svg';
import ClockIn from './svgs/clock-in.svg';
import ClockOut from './svgs/clock-out.svg';
import TimelineLocation from './svgs/timeline-location.svg';
import TimelineClockInOut from './svgs/timeline-clock-in-out.svg';
import LocationCheckIn from './svgs/location-check-in.svg';
import OrderPlaced from './svgs/order-placed.svg';
import ZotokPinRed from './svgs/zotok-pin-red.svg';
import ZotokPinGreen from './svgs/zotok-pin-green.svg';
import ZotokPinPurple from './svgs/zotok-pin-purple.svg';
import LocationNotAvilable from './svgs/location-not-found.svg';
import PaymentCollect from './svgs/payment-collected.svg';
import Navigation from './svgs/navigation.svg';
import NavigationComp from './svgs/navigation.svg?component';
import InvoiceDoc from './svgs/invoice_doc.svg';
import BackArrowLT from './svgs/backArrowlight.svg';
import LeftArrowIcon from './svgs/arrow_left.svg';
import LocationIcon from './svgs/location-icon.svg';
import KebabMenu from './svgs/kebab-menu.svg';
import KebabMenuNewIcon from './svgs/kebab_menu_newIcon1.svg';
import KebabMenuComp from './svgs/kebab-menu.svg?component';
import ShareIcon from './svgs/share.svg';
import ShareIconComp from './svgs/share.svg?component';
import CloneIcon from './svgs/clone.svg';
import CloneIconComponent from './svgs/clone-blue.svg?component';
import CloneWhiteIcon from './svgs/copy-new.svg';
import Copy from './svgs/copy-icon.svg';
import copySvg from './svgs/copy-icon.svg?component';
import DotmenuIcon from './svgs/3dot_menuIcon.svg';
import DotmenuActiveIcon from './svgs/3dot_menuActiveIcon.svg';
import EnableIcon from './svgs/enableIcon.svg';
import DisableIcon from './svgs/disableIcon.svg';
import superAdminUpdateIcon from './svgs/adminVector.svg';
import superAdminRewindIcon from './svgs/Rewind.svg';
import ResendIcon from './svgs/resend-black.svg';
import ResendBlueIcon from './svgs/resend-blue.svg';
import ResetIcon from './svgs/resend-black.svg';
import PublishIcon from './svgs/Publish_Send.svg';
import ZoCoinIcon from './svgs/zo-coin.svg';
import ListView from './svgs/list-view.svg';
import GalleryView from './svgs/gallery-view.svg';
import DownArrowBlue from './svgs/arrow_down-blue.svg';
import RoiIcon from './svgs/roi-icon.svg';
import VectorIcon from './svgs/Vector.svg';
import CampaignIcon from './svgs/campaign1.svg?component';
import ApprovalIcon from './svgs/approval-icon.svg?component';
import OutlineWarning from './svgs/outlined-warning.svg?component';
import OutlineWarningIcon from './svgs/outlined-warning.svg';
import MertricsIcon from './svgs/metrics-icon.svg';
import ClickIcon from './svgs/click.svg';
import KPIIcon from './svgs/kpi.svg';
import PinnedIcon from './svgs/pinned.svg';
import UnPinnedIcon from './svgs/un-pinned.svg';
import TrendingUpIcon from './svgs/ic-trending-up.svg';
import TrendingDownIcon from './svgs/ic-trending-down.svg';
import ComboView from './svgs/combo_view.svg?component';
import ChartIcon from './svgs/chart-icon.svg?component';
import ConfigSetting from './svgs/config-setting.svg';
import ErrorIcon from './svgs/error.svg';
import ErrorIconNew from './svgs/error-icon-new.svg';
import Click from './svgs/click-icon.svg';
import OrderIcon_ from './svgs/order-icon.svg';
import OrderIconComponent from './svgs/order-icon.svg?component';
import RightBlack from './svgs/right-black.svg';
import RightGrey from './svgs/right-grey.svg';
import RightBlue from './svgs/right-blue.svg';
import Right from './svgs/right.svg?component';
import Roi from './svgs/roi.svg';
import ViewIcon from './svgs/view.svg';
import BeatPlanIcon from './svgs/beat-plan.svg';
import CustomersIcon from './svgs/customersTabIcon.svg?component';
import AddCustomersIcon from './svgs/add-customers-icon.svg';
import RouteRigthIcon from './svgs/route.svg';
import UserIconWithArrows from './svgs/user-icon-arrows.svg';
import CaretDownIconNew from './svgs/caret-Down-Icon.svg?component';
import CaretRightIconNew from './svgs/caret-Right-Icon.svg?component';
import ProductIcon from './svgs/product-icon.svg?component';
import GraphIcon from './svgs/graph.svg?component';
import RightIcon from './svgs/right-blue.svg?component';
import PlusOutline from './svgs/plus-outline.svg';
import PlusOutineWhite from './svgs/plus-outline-white.svg';
import InfoNew from './svgs/info-icon-new.svg';
import InfoIconBlack from './svgs/InfoIcon-black.svg';
import MuteNewIcon from './svgs/mute-icon.svg';
import AgentLeadsIcon from './svgs/Agent-leads-icon.svg';
import AgentLeadsActiveIcon from './svgs/Agent-leads-active-icon.svg';
import TeamMemberLeadIcon from './svgs/Team-member-lead-icon.svg';
import TeamMemberLeadActiveIcon from './svgs/Team-member-lead-active-icon.svg';
import MessageWaitMinutesIcon from './svgs/Message-wait-minutes-icon.svg';
import InfoIconComponent from './svgs/InfoIcon-black.svg?component';
import DefaultProduct from './svgs/default-product.svg';
import NoResults from './svgs/no-results.svg';
import DownArrow from './svgs/down-arrow.svg';
import DownArrowComp from './svgs/down-arrow.svg?component';
import UpArrowComp from './svgs/arrow-up-new.svg?component';
import SelectArrowDownComp from './svgs/select_arrow_down.svg?component';
import SelectArrowUpComp from './svgs/select_arrow_up.svg?component';
import ArrowUpNew from './svgs/arrow-up-new.svg';
import ArrowUpIcon from './svgs/arrow-up-icon.svg';
import RefreshIconCampaign from './svgs/refresh-icon-campaign.svg';
import MiscTagForCustomer from './svgs/miscTagForCustomer.svg';
import NeutralGrey from './svgs/Neutral-grey.svg';
import Image from './svgs/image.svg';
import Loader from './svgs/loader.svg';
import CampaignDefaultImg from './svgs/campaign-default.svg';
import Campaign from './svgs/campaign.svg';
import CampaignBlack from './svgs/CampaignBlack.svg?component';
import DefaultPicture from './svgs/default-picture.svg';
import TimeIcon from './svgs/time-icon.svg';
import ArrowLeftIcon from './svgs/arrowLeft.svg';
import NonSelectIcon from './svgs/none_select.svg';
import View from './svgs/view-icon.svg';
import CloseRed from './svgs/closeRed.svg';
import whiteCloseIcon from './svgs/close.svg';
import ArrowDownDark from './svgs/arrowDownBlack.svg';
import ArrowDownBlue from './svgs/arrowDownBlue.svg';
import CampaignDefaultTemplate from './svgs/campaign-default-template.svg';
import ProductDefaultTemplate from './svgs/product-default-template.svg';
import CampaignDefaultTemplateVideo from './pngs/campaign-default-template-video.png';
import CampaignDefaultTemplateVideoDefault from './pngs/campaign-default-template-video-default.png';
import CampaignDefaultTemplateDoc from './svgs/campaign-default-template-doc.svg';
import CampaignDefaultTemplateLocation from './svgs/campaign-default-template-location.svg';
import DocumentColor from './svgs/document-color.svg';
import DefaultCheckboxNew from './svgs/default-checkbox-new.svg';
import SearchIconNew from './svgs/search_Icon_New.svg';
import NoDivisionsIcon from './svgs/NoDivision_Icon.svg';
import CheckedCheckboxNew from './svgs/checked-checkbox-new.svg';
import NeutralCheckboxNew from './svgs/neutral-checkbox-new.svg';
import DownloadHistory from './svgs/download_history.svg';
import ThreadsNoView from './pngs/threads-no-view.png';
import FileNew from './svgs/file-new.svg';
import FileUpload from './svgs/file-upload.svg';
import FileUploadNewIcon from './svgs/upload_file-newIcon.svg';
import FileUploadComponent from './svgs/file-upload.svg?component';
import FileUploadBlue from './svgs/file-upload-blue.svg';
import ToggleOpen from './svgs/toggle_open.svg';
import ToggleClose from './svgs/toggle_close.svg';
import InvalidFile from './pngs/invalid-file.png';
import ImageUpload from './pngs/image-upload.png';
import tagBlackIcon from './svgs/tagBlack.svg';
import wabaIcon from './svgs/waba.svg';
import Danger from './svgs/danger.svg';
import Free from './svgs/Free.svg';
import Offer from './svgs/offer.svg';
import DoubleTick from './svgs/double_tick.svg';
import leftDown from './svgs/left_down.svg';
import CheckoutPng from './pngs/checkout.png';
import tagWhiteIcon from './svgs/tagWhite.svg';
import SendArrowBlack from './svgs/sendArrowBlack.svg';
import SendArrowComponent from './svgs/sendArrowBlack.svg?component';
import Delete from './pngs/delete.png';
import DeleteSchemeIcon from './pngs/Delete-Icon-New.png';
import DeleteWhiteIcon from './svgs/delete-white-icon.svg';
import Disconnect from './pngs/disconnect.png';
import connect from './svgs/connect.svg';
import ConnectBlueIcon from './svgs/connect-blue.svg';
import upgradeIcon from './svgs/upgrade.svg';
import compairIcon from './svgs/Compair.svg';
import closeBlackIcon from './svgs/closeBlackIcon.svg';
import CloseFilled from './svgs/close-filled.svg?component';
import BankIcon from './svgs/bank.svg';
import BankEmptyStateImage from './pngs/bank-empty-state.png';
import UpiEmptyStateImage from './pngs/upi-empty-state.png';
import PendingInvoice from './pngs/pending-invoice.png';
import DropdownOpen from './svgs/dropdownOpen.svg';
import DropdownClose from './svgs/dropdownClose.svg';
import BankAccount from './svgs/bankAccount.svg';
import Upi from './svgs/upi.svg';
import CloudUpload from './svgs/cloudUplaod.svg?component';
import CloudUploadBlue from './svgs/cloud-upload-blue.svg';
import CloudUploadIcon from './svgs/cloud-upload-icon.svg';
import VerificationSuccess from './svgs/verification-success.svg?component';
import VerificationSuccessIcon from './svgs/verification-success.svg';
import ErrorIconRed from './svgs/error-icon-red.svg?component';
import DownloadWhite from './svgs/download-white.svg?component';
import DownloadWhiteIcon from './svgs/download-white.svg';
import zoeyIcon from './svgs/zoey-icon.svg';
import NoDataGraph from './pngs/no-data-graph.png';
import FallbackIcon from './svgs/FallbackIcon.svg';
import ZoeyIconComponent from './svgs/zoey-icon.svg?component';
import WhatsAppGrid from './pngs/whatsapp-grid.png';
import BulbIcon from './svgs/bulb.svg';
import ImgPlaceholder from './svgs/img-placeholder.svg';
import BankAvatar from './pngs/bank.png';
import QRAvatar from './pngs/qr.png';
import BulletDefault from './svgs/bullet-default.svg';
import BulletIcon from './svgs/bullet-icon.svg';
import Refresh from './svgs/Refresh.svg?component';
import PencilLarge from './svgs/pencilLarge.svg?component';
import PencilLargeWabaMaster from './svgs/pencilLarge.svg';
import SharedGrey from './svgs/shareGrey.svg?component';
import DownloadFile from './svgs/downloadFile.svg?component';
import SearchEnter from './svgs/search-enter.svg';
import ThreadIcon from './svgs/thread.svg?component';
import DateIcon from './svgs/date.svg?component';
import AddCircleUnfilled from './svgs/add_circle.svg?component';
import AddCircleIcon from './svgs/add_circle.svg';
import GrowWhatsappCrmIcon from './svgs/grow-whatsapp-crm-Icon.svg';
import MarketingFunelIcon from './svgs/marketingFunelIcon.svg';
import SalesFunelIcon from './svgs/salesFunelIcon.svg';
import ConversationsFunelIcon from './svgs/conversationsFunelIcon.svg';
import PopupFunelLoadingIcon from './svgs/popupFunelLoadingIcon.svg';
import PopupFunelSuccessIcon from './svgs/popupFunelSuccessIcon.svg';
import SetupDefaultFunelIcon from './svgs/setupDefaultFunelIcon.svg';
import SettingsFunnelIcon from './svgs/Settings_Funnel.svg';
import SettingsBlue from './svgs/settings-blue.svg';
import GrowDashboardInitViewBgImage from './pngs/GrowDashboardInitView_BgImage.png';
import NotificationFilled from './svgs/NotificationFilled.svg?component';
import CampaignFilled from './svgs/CampaignFilled.svg?component';
import TemplatePreviewBottom from './svgs/template-preview-bottom.svg?component';
import PriceList from './svgs/price-list.svg';
import External_Link from './svgs/External_Link.svg?component';
import link_url from './svgs/link_url.svg?component';
import FileUploadImage from './pngs/file_upload.png';
import TemplateMangerBackground from './pngs/TemplateManagerBackground.png';
import CheckWhiteIcon from './svgs/check_white.svg';
import MinusIconBlack from './svgs/minus-icon-black-new.svg';
import UploadBlueIcon from './svgs/upload-file-blue.svg';
import AddIcon from './svgs/add-icon.svg';
import AddBlueIcon from './svgs/add-blue.svg';
import AddBlueNewIcon from './svgs/add-blue-new-icon.svg?component';
import MinusBlueNewIcon from './svgs/minus-blue-new-icon.svg?component';
import ReplyComp from './svgs/Reply.svg?component';
import ListViewComp from './svgs/list_view.svg?component';
import DragHandleComp from './svgs/drag-handle.svg?component';
import UploadOrder from './pngs/upload-order.png';
import InfoBlue3d from './pngs/info-blue-3d.png';
import UploadFileBlack from './svgs/upload-file-black.svg';
import PaperPinBlack from './svgs/paper-pin-black.svg';
import FilterIcon from './svgs/filter.svg?component';
import CloseIconNew from './svgs/closeIconNew.svg';
import CloseIconNewComp from './svgs/closeIconNew.svg?component';
import DiscountIconNew from './pngs/discount-icon.png';
import FreeImage from './pngs/free_image.png';
import UploadWhiteIcon from './svgs/upload-file-white.svg';
import ParseFileIcon from './svgs/parse-file.svg';
import ImageIcon from './svgs/image-icon.svg';
import ReminderIcon from './svgs/reminder-icon.svg';
import ReminderIconNew from './svgs/reminder-iconNew.svg?component';
import FreeBadgeLottie from './lotties/free_badge_lottie.json';
import OfferDiscountLottie from './lotties/offer_discount_lottie.json';
import LoadingLottie from './lotties/loader.json';
import ProductsEmpty from './pngs/products-empty.png';
import BuildCustomerList from './pngs/build-customer-list.png';
import ManageCatalogue from './pngs/manage-catalogue.png';
import PublishCampaign from './pngs/publish-campaign.png';
import Whatsapp from './pngs/whatsapp.png';
import StartIcon from './svgs/start-icon.svg';
import Seen from './svgs/seen.svg';
import Deliverd from './svgs/delivered.svg';
import DeliverdIconNew from './svgs/delivered-icon-new.svg';
import Sent from './svgs/sent.svg';
import SentIconNew from './svgs/sent-new-Icon.svg';
import SeenIconNew from './svgs/seen-icon-new.svg';
import NotificationThreadIcon from './svgs/notificationThreadIcon.svg';
import NotificationZoeyIcon from './svgs/notificationZoeyIcon.svg';
import NotificationWAppSyncedIcon from './svgs/notificationWAppSyncedIcon.svg';
import NotificationTransactionIcon from './svgs/notificationTransactionIcon.svg';
import TickDoneCheck from './svgs/tick-done-check.svg';
import ArrowRightWhite from './svgs/arrow_right_white.svg';
import SettingsBlack from './svgs/settings-black.svg';
import SettingsIconComponent from './svgs/settings-black.svg?component';
import ExternalBlack from './svgs/external-link-black.svg';
import ExternalBlackComp from './svgs/external-link-black.svg?component';
import SearchIcon from './svgs/searchIcon.svg';
import EnterIcon from './svgs/enter_mac_key.svg';
import DiscountOfferSVG from './svgs/discount_offer.svg';
import FreeOfferSVG from './svgs/free_offer.svg';
import LoadingAnimationGif from './gifs/loading-animation.gif';
import BookOrderView from './svgs/book-order-view.svg';
import BookEnquiries from './svgs/book-enquiries-view.svg';
import BulkUploadSuccess from './svgs/bulk-upload-success.svg';
import TopUpSuccessLottie from './lotties/topup_success_lottie.json';
import TopUpFailureLottie from './lotties/topup_failure_lottie.json';
import WelcomeSplashLottie from './lotties/Welcome.json';
import NoTemplates from './svgs/no-templates.svg';
import ThankYou from './pngs/thank-you.png';
import HourGlass from './svgs/hour-glass.svg';
import NoInvoicesImage from './pngs/no-invoices-image.png';
import NoCustomersImage from './pngs/no-customers-image.png';
import NoPaymentsImage from './pngs/no-payments-image.png';
import NoPriceListsImage from './pngs/no-pricelist-image.png';
import NoReturnsImage from './pngs/no-returns-image.png';
import NoSchemesImage from './pngs/no-schemes-image.png';
import NoLedgersImage from './pngs/no-ledgers-image.png';
import NoProductsImage from './pngs/no-product-image.png';
import NoCategoryImage from './pngs/no-categories-image.png';
import NoOrdersImage from './pngs/no-order-image.png';
import NoDispatchImage from './pngs/no-dispatch-image.png';
import NoSearchResultsImage from './pngs/no-search-results.png';
import NoFormsImage from './pngs/no-forms-image.png';
import NoReportsImage from './pngs/no-reports-image.png';
import NoTeamMembers from './pngs/no-team-members.png';
import NoWabaImage from './pngs/no-waba-image.png';
import NoPersonalWhatsapp from './pngs/no-personal-whatsapp.png';
import NoBotsImage from './pngs/no-bots-image.png';
import NoSyncImage from './pngs/no-sync-image.png';
import NoImportsImage from './pngs/no-imports-image.png';
import NoCfaImage from './pngs/no-cfa-image.png';
import cfaLocationIcon from './pngs/cfa-location-icon.png';
import NoSegmentChart from './pngs/no-segments-chart.png';
import NoHeadDivisions from './pngs/no-head-divisions.png';
import NoDivisionsImage from './pngs/no-divisions-image.png';
import NoFilteredResults from './pngs/no-filtered-results.png';
import NoChannelsImage from './pngs/no-channels-image.png';
import UploadBulkFile from './pngs/upload-bulk-file.png';
import NoBulkUploads from './pngs/no-bulk-uploads.png';
import NoCategoriesImage from './pngs/no-categories-image.png';
import NoRoutesImage from './pngs/no-routes-image.png';
import NoSegmentsImage from './pngs/no-segments-image.png';
import NoCustomerThreads from './pngs/no-customer-threads.png';
import NoIssueThreads from './pngs/no-issue-threads.png';
import NoGroupThreads from './pngs/no-group-threads.png';
import NoCampaignsImage from './pngs/no-campaigns-image.png';
import NoCampaignRevenue from './pngs/no-campaign-revenue.png';
import NoRevenueBreakdown from './pngs/no-revenue-breakdown.png';
import NoLocationDimensions from './pngs/no-location-dimensions.png';
import NoChannelDimensions from './pngs/no-channel-dimensions.png';
import NoProductDimensions from './pngs/no-product-dimensions.png';
import AssignTeamMemberEmpty from './pngs/assign-team-members.png';
import NoDownloadsImage from './pngs/no-downloads-image.png';
import NoUnreadMessages from './pngs/no-unread-messages.png';
import NoFeedsImage from './pngs/no-feeds-image.png';
import customersPng from './pngs/customers.png';
import locationPng from './pngs/location.png';
import CrossIconCircleRedComponent from './svgs/cross-icon-circle-red.svg?component';
import CrossIconCircleRed from './svgs/cross-icon-circle-red.svg';
import SuccessTickIcon from './svgs/success-tick-icon.svg';
import GreenCheckIcon from './svgs/Check.svg';
import HomeComp from './svgs/Home.svg?component';
import ManageCatalogueComp from './svgs/ManageCatalogue.svg?component';
import SetupWABA from './svgs/SetupWABA.svg?component';
import Task_Done from './svgs/tick-done-check.svg?component';
import CheckComp from './svgs/Check.svg?component';

import OnBoardingpopuptopIcon from './svgs/onBoardingpopuptopIcon.svg?component';
import GrowRevenuWhatsAppIcon from './svgs/GrowRevenuWhatsAppIcon.svg?component';
import IncreaseGrowthIcon from './svgs/IncreaseGrowthIcon.svg?component';
import ImproveCollectionPaymentIcon from './svgs/ImproveCollectionPaymentIcon.svg?component';
import AutomateCustomerResponseIcon from './svgs/AutomateCustomerResponseIcon.svg?component';
import BuildCustomerListComp from './svgs/builld-customer-list.svg?component';
import ChecklistDrawerBackground from './svgs/ChecklistDrawerBackground.svg?component';
import RightArrowComp from './svgs/right_arrow.svg?component';
import PlaceholderComp from './svgs/placeholder-comp.svg?component';
import ChecklistCompletedComp from './svgs/Success_Tick.svg?component';
import ConnectSuccess from './svgs/SuccessConnect.svg';
import ConnectError from './svgs/connect-error.svg';
import ConnectLoading from './pngs/connect-loading.png';
import RadioSelected from './svgs/radio-selected.svg';
import InactiveRadio from './svgs/Inactive-radio.svg';
import RadioUnselected from './svgs/radio-unselected.svg';
import AppsAndConsent from './svgs/apps-consent.svg?component';
import Synchronize from './svgs/synchronize.svg?component';
import ZotokAppsLogo from './svgs/zotok-app-logo.svg';
import ZoTokApiLogo from './svgs/zotok-api-logo.svg';
import TallyLogo from './svgs/tally-logo.svg';
import TallyIcon from './pngs/tally.png';
import ExternalLinkBlueIcon from './svgs/external-link-blue.svg';
import SuccessTickMedium from './svgs/success-tick-medium.svg';
import FieldTypeTextIconComponent from './svgs/field-type-text.svg?component';
import FieldTypeNumberIconComponent from './svgs/field-type-number.svg?component';
import FieldTypeTimeIconComponent from './svgs/field-type-time.svg?component';
import FieldTypeDropdownIconComponent from './svgs/field-type-dropdown.svg?component';
import FieldTypeCheckboxIconComponent from './svgs/field-type-checkbox.svg?component';
import FieldTypeDateIconComponent from './svgs/field-type-date.svg?component';
import FieldTypeTimeIcon from './svgs/field-type-time.svg';
import GroupsTabIcon from './svgs/groups-tab-icon.svg';
import UploadIconFillBlue from './svgs/upload-icon-fill-blue.svg';
import NoCustomFieldsImage from './pngs/no-custom-fields-image.png';
import DeactivateIconRed from './svgs/deactivate.svg';
import ShopifyIcon from './svgs/shopify-icon.svg';
import RazorpayIcon from './svgs/razorpay-icon.svg';
import InfobipIcon from './svgs/infobip_Logo.svg';
import SecuresmscIcon from './svgs/Securesmsc-icon.svg';
import GoogleSheetIcon from './svgs/googlesheet-icon.svg';
import GoogleIcon from './pngs/Google-icon.png';
import plusIconComponent from './svgs/plus.svg?component';
import OoduIcon from './svgs/oodu-icon.svg';
import ThreeDotIconComp from './svgs/ThreeDotMenuIconComp.svg?component';
import MetaIcon from './pngs/meta-logo.png';
import MetaIcon_ from './svgs/meta-icon.svg';
import IndiaMartIconNew from './svgs/India-Mart-Icon.svg';
import RefreshIconNew from './svgs/refresh-icon.svg';
import ArrowDownWhite from './svgs/arrow-down-white.svg';
import FailedImage from './pngs/failed-image.png';
import ExternalLinkWhite from './svgs/external-link-white.svg';
import ZoaiAnalysis from './pngs/zoai-analysis.png';
import ZohoDeleteIcon from './pngs/Zoho_Delete_Icon.png';
import GenerateKey from './svgs/key-icon.svg';
import GenerateKeyBlue from './svgs/key-icon-blue.svg';
import ConnectIcon from './svgs/connect.svg';
import CloseIconSmall from './svgs/close-small.svg';
import ToggleOff from './svgs/toggle-off.svg';
import ToggleOnActive from './svgs/ToggleOnActive_Icon.svg';
import ToggleOffDeActive from './svgs/ToggleOffDeactivate_Icon.svg';
import ViewEye from './svgs/view-eye.svg';
import ViewEyeNew from './svgs/ViewNew_Icon.svg';
import EyeIconBlue from './svgs/eye-icon-blue.svg';
import NoDynamicSegements from './pngs/no-dynamic-segments.png';
import dynamicSegment from './svgs/dynamic-segment.svg?component';
import CustomersStatsIcon from './svgs/Customers-Stats-icon.svg?component';
import FilterIconLarge from './pngs/filter-icon.png';
import GroupIcon from './svgs/group-icon.svg';
import CloseIconSmallGrey from './svgs/close-small-grey.svg';
import Filter from './svgs/filter.svg';
import CustomersIconNew from './svgs/customers-icon.svg';
import CustomersIconNewComp from './svgs/customers-icon.svg?component';
import RefreshIconBlue from './svgs/refresh-icon-blue.svg';
import RefreshIconGrey from './svgs/refresh-icon-grey.svg';
import AllCfa from './svgs/all-cfa.svg';
import AllCustomers from './svgs/all-customer.svg';
import FolderClosed from './svgs/folder-closed.svg?component';
import BusinessContact from './pngs/business-contact.png';
import AssignLocation from './pngs/assign-location.png';
import PersonalContact from './pngs/personal-contact.png';
import TickDoneCheckGreen from './svgs/tick-done-check-green.svg';
import FolderIcon from './svgs/folder-icon.svg';
import NoRoutes from './pngs/no-routes.png';
import FolderMinimise from './svgs/folder-minimize.svg';
import FolderMaximize from './svgs/folder-maximize.svg';
import NoCustomers from './pngs/no-customers.png';
import DeleteFolder from './pngs/delete-folder.png';
import AgentTasksPlaceholder from './pngs/agent-tasks-placeholder.png';
import AgentKnowledge1 from './pngs/agent-knowledge-placeholder-1.png';
import AgentKnowledge2 from './pngs/agent-knowledge-placeholder-2.png';
import AgentKnowledge3 from './pngs/agent-knowledge-placeholder-3.png';
import FacebookSystemAccessToken from './pngs/Facebook-System-AccessToken.png';
import PdfIcon from './svgs/pdf.svg';
import CSVIcon from './svgs/CSV.svg';
import CloseRedIconRounded from './svgs/closeRed.svg';
import DeleteNewIconComponent from './svgs/deleteNew.svg?component';
import WalletComp from './svgs/Wallet.svg?component';
import WelcomeCup from './pngs/welcome-cup.png';
import WelcomeCard1 from './pngs/welcome-card-1.png';
import BulbWithSettings from './svgs/bulb-with-settings.svg';
import WelcomeLayer1 from './pngs/welcome-layer-1.png';
import WelcomeLayer2 from './pngs/welcome-layer-2.png';
import WelcomeScreenImage from './pngs/welcome-screen-image.png';
import AutomateBusinessImage from './pngs/automate-business-image.png';
import CaptureOrdersImage from './pngs/capture-orders-image.png';
import IntegrateFieldImage from './pngs/integrate-field-image.png';
import LetAIHandleImage from './pngs/letAI-handle-image.png';
import SmartCampaignsImage from './pngs/smart-campaigns-image.png';
import ProductsTooltipImage from './pngs/products-tooltip-image.png';
import WelcomeScreenMask from './pngs/welcome-screen-mask.png';
import NoVisits from './pngs/no-visits.png';
import AvatarNew from './svgs/avatar-new.svg?component';
import RedCircleOutlined from './svgs/red-circle-outlined.svg';
import GreenSquareOutlined from './svgs/green-square-outlined.svg';
import GreenDiamondFill from './svgs/green-diamond-fill.svg';
import YellowCircleFill from './svgs/yellow-circle-fill.svg';
import BlueTriangleFill from './svgs/blue-triangle-fill.svg';
import DeleteFilesImage from './pngs/delete-files-image.png';
import ChatIcon from './svgs/chat-icon.svg';
import BotIcon from './svgs/bot-icon.svg';
import BotLibrary from './svgs/bot-library.svg';
import PieIcon from './svgs/pie-icon.svg';
import PreviewFlowImage from './pngs/preview-flow-image.png';
import AddCircleWhite from './svgs/add-circle-white.svg';
import ParentVariantView from './pngs/parent-variant-view.png';
import ThumbnailView from './pngs/thumbnail-view.png';
import ExcelView from './pngs/excel-view.png';
import GenerationFailedImage from './pngs/generation-failed-image.png';
import LoadingAnimationLottie from './lotties/loading_animation_lottie.json';
import PublishOnWhatsapp from './pngs/publish-on-whatsapp.png';
import PublishOnWhatsappNew from './svgs/publish-on-whatsappNew1.svg';
import PublishOnCtwa from './pngs/publish-on-ctwa.png';
import PublishOnCtwaNew from './svgs/publish-on-ctwaNew.svg';
import FacebookWhiteIcon from './svgs/facebook-icon.svg';
import WhatsappBlackIcon from './svgs/whatsapp-black.svg';
import WhatsappWhiteIcon from './svgs/Whatsapp_whiteFill.svg';
import LeftArrowBlack from './svgs/left-arrow-black.svg';
import WhatsappPhone from './pngs/whatsapp-phone.png';
import FacebookPhone from './pngs/facebook-phone.png';
import StatusBarIcons from './pngs/status-bar-icons.png';
import BackBlueIcon from './svgs/back-blue-icon.svg';
import VideoCallIcon from './svgs/video-call-icon.svg';
import AudioCallIcon from './svgs/audio-call-icon.svg';
import ProfileIcon from './pngs/profile-icon.png';
import MobileWhatsappBackground from './pngs/mobile-whatsapp-background.png';
import StickersBlueIcon from './svgs/stickers-blue-icon.svg';
import AddMediaIcon from './svgs/add-blue-icon.svg';
import EmptyProfile from './pngs/empty-profile.png';
import FacebookLikes from './pngs/facebook-likes.png';
import FacebookIcons from './pngs/facebook-icons.png';
import WareHouse from './pngs/warehouse 1.png';
import Shop from './pngs/shop 1.png';
import StreetCoffeeStall from './pngs/street-coffee-stall 1.png';
import BusinessmanSolvingCustomrDoubts from './pngs/businessman-is-solving-customer-doubts 1.png';
import CampaignImg from './pngs/campaign.png';
import BotImg from './pngs/bot.png';
import InvoiceImg from './pngs/invoice.png';
import PaymentImg from './pngs/payment.png';
import RupeeImg from './pngs/rupee-coin.png';
import CalendarImg from './pngs/calendar.png';
import FreeImg from './pngs/free.png';
import SegmentsTabIcon from './svgs/segments-icon.svg?component';
import AiDrivenRepliesIcon from './svgs/AiDrivenReplies_Icon.svg';
import AutoSendInvoicesIcon from './svgs/AutoSendInvoices_Icon.svg';
import AutoSendLedgersIcon from './svgs/AutoSendLedgers_Icon.svg';
import BoostSalesReachIcon from './svgs/BoostSalesReach_Icon.svg';
import ManageEnquiriesicon from './svgs/manageEnquiries_icon.svg';
import SubtractSign from './svgs/subtract.svg';
import PlusSign from './svgs/plus_math.svg';
import EqualSign from './svgs/equal_sign.svg';
import CTWAAdsIcon from './svgs/CTWAAds_Icon.svg';
import EnhanceLoyaltyIcon from './svgs/EnhanceLoyalty_Icon.svg';
import AnalyzeGrowthIcon from './svgs/AnalyzeGrowth_Icon.svg';
import WhatsAppOrderingIcon from './svgs/WhatsAppOrdering_Icon.svg';
import MessageIcon from './svgs/message-icon.svg';
import HomeLocation from './svgs/HomeLocation.svg';

import Bysegments from './svgs/by-segments.svg';
import Standard from './svgs/standard-icon.svg';
import OnClickIcon from './svgs/on-click.svg';
import BotMoreIcon from './svgs/bot-more-action.svg';
import CustomerCountIcon from './svgs/Customercounter.svg';

import SendBlueIcon from './svgs/send-blue-icon.svg';
import CampaignFacebook from './svgs/campaignFacebook.svg';
import CampaignGraphView from './svgs/MoreActions.svg';
import CampaignGraphHide from './svgs/MoreActionIcon.svg';
import CampaignGraphShowIcon from './svgs/CampaignGraphShow_Icon.svg';
import CampaignGraphShowHoverIcon from './svgs/CampaignGraphShowHover_Icon.svg';
import CampaignGraphHideIcon from './svgs/CampaignGraphHide_Icon.svg';
import CampaignGraphHideHoverIcon from './svgs/CampaignGraphHideHover_Icon.svg';
import LegalDocuments from './svgs/legal-documents.svg';
import WebsiteEmail from './svgs/website-email.svg';
import WabaSetupIcon from './pngs/waba-setup-icon.png';
import ZonoMoneySimulatorHeader from './pngs/zono-money-header.png';
import ZonoMoneySimulatorFooter from './pngs/zono-money-footer.png';
import IndiaMartIcon from './pngs/india-mart.png';
import WabaSetupNudgeIcon from './pngs/waba-setup-nudge.png';
import ShippingIcon from './pngs/shipping.png';
import ZoomIn from './svgs/zoom-in.svg';
import ZoomOut from './svgs/zoom-out.svg';
import AiIcon from './svgs/ai-icon.svg';
import FunnelIcon from './svgs/funnel-icon.svg';
import LoyalCustomersIcon from './svgs/loyal-customers-icon.svg';
import LoyalCustomersIconNew from './svgs/loyal-customers-iconNew.svg';
import InfrequentCustomersIcon from './svgs/infrequent-customers-icon.svg';
import InfrequentCustomersIconNew from './svgs/infrequent-customers-iconNew.svg';
import DormantCustomersIconNew from './svgs/dormant-customers-iconNew.svg';
import PotentialCustomersIcon from './svgs/potential-customers-icon.svg';
import PotentialCustomersIconNew from './svgs/potential-customers-iconNew.svg';
import NudgeCustomersIconNew from './svgs/nudge-customers-iconNew.svg';
import MeaningfulConversationsIconNew from './svgs/meaningful-conversations-iconNew.svg';
import TargetCampaignsIcon from './svgs/target-campaigns-icon.svg';
import TargetCampaignsIconNew from './svgs/target-campaigns-iconNew.svg';
import CompareFiles from './svgs/compare-files.svg';

import PersonalizeCatalogueIconNew from './svgs/personalize-catalogue-iconNew.svg';
import ExploreCatalogueIconNew from './svgs/explore-catalogue-iconNew.svg';
import SpecificOffersIconNew from './svgs/specific-offers-iconNew.svg';
import CatalogExperienceIcon from './svgs/catalog-experience-icon.svg';
import CatalogExperienceIconNew from './svgs/catalog-experience-iconNew.svg';
import OrderFormatIconNew from './svgs/order-format-iconNew.svg';
import WhatsappOutlinedIcon from './svgs/whatsapp-outlined-icon.svg';
import NotifyCustomersIcon from './svgs/notify-customers-icon.svg';
import FolderGrey from './svgs/folder-grey.svg';
import WorkFlow from './svgs/work-flow.svg';
import WorkFlowComponent from './svgs/work-flow.svg?component';
import Manual from './svgs/manual.svg';
import Automatic from './svgs/automatic.svg';
import AutomaticComponent from './svgs/automatic.svg?component';
import RightArrowBlack from './svgs/right-arrow-black.svg';
import ArrowRightBlue from './svgs/arrow-right-blue.svg';
import TemplateIconComponent from './svgs/templates-icon.svg?component';
import LineChartComponent from './svgs/line-chart-icon.svg?component';
import BotImage from './pngs/bot-image.png';

// import MetaIcon from './svgs/meta-icon.svg';
// import WhatsAppBusinessPhone from './svgs/whatsapp-business-phone.svg';
// import FacebookBusinessManagerAccount from './svgs/facebook-business-manager-account.svg';
import WhatsAppIconOutlined from './svgs/whatsapp-icon-outlied.svg';
import WhatsAppDisabledIconOutlined from './svgs/Whatsapp-disabled-outlined.svg';
import InvoicePDF from './svgs/invoice-pdf.svg';
import DeduplicationSetupIcon from './svgs/deduplicationSetupIcon.svg';
import EditIconBlack from './svgs/edit-icon.svg';
import EditIconWhite from './svgs/edit-icon-white.svg';
import Chat from './svgs/Chat.svg?component';
import Esacalate from './svgs/Escalate.svg?component';
import AgentOrderIcon from './svgs/agent-order-icon.svg?component';
import AgentOutstandingIcon from './svgs/agent-outstanding-icon.svg?component';
import AgentLedgerIcon from './svgs/agent-ledger-icon.svg?component';
import AgentKnowledgeIcon from './svgs/agent-knowledge-icon.svg?component';
import AgentInvoiceIcon from './svgs/agent-invoice-icon.svg?component';
import AgentCatalogIcon from './svgs/agent-catalog-icon.svg?component';
import AgentPaymentIcon from './svgs/agent-payment-icon.svg?component';
import AgentAccountIcon from './svgs/aigent-acount-icon.svg?component';
import AgentQueryIcon from './svgs/aigent-query-icon.svg?component';
import AgentWelcomeIcon from './svgs/aigent-welcome-icon.svg?component';
import Ledger from './svgs/Ledger.svg?component';
import Order_ from './svgs/order-black.svg?component';
import Parse from './svgs/Parse.svg?component';
import Payment_ from './svgs/Payment.svg?component';
import ProductTabIcon from './svgs/product-icon.svg';
import Product from './svgs/Product.svg?component';
import Search from './svgs/search.svg?component';
import SynchronizeBlue from './svgs/synchronize-blue.svg';
import MappingArrow from './svgs/mapping-arrow.svg';
import KnowledgeAgent from './svgs/knowledge-agent.svg?component';
import GridViewBlack from './svgs/grid-view-black.svg';
import GridViewWhite from './svgs/grid-view-white.svg';
import flowBotIcon from './svgs/flowBotIcon.svg';
import AddCircleBlueOutlined from './svgs/add-circle-blue-outlined.svg';
import DocumentScannLottie from './lotties/document-scan.json';
import GrowSetupLoaderLottie from './lotties/grow-setup-loader.json';
import RotateAntiClockWhite from './svgs/rotate-anticlock-white.svg';
import InfoFillIconComponent from './svgs/info-fill-icon.svg?component';
import InfoFillWhiteIconComponent from './svgs/info-fill-white-icon.svg?component';
import EventsIcon from './svgs/events-icon.svg';
import ServiceIcon from './svgs/service-icon.svg';
import CatalogueSync from './svgs/catalogue-sync.svg';
import ManualOfferIcon from './pngs/manual-offer.png';

import SFTPIcon from './pngs/sftp.png';
import FileZillIcon from './svgs/filezilla.svg';
import WinSEPIcon from './svgs/winsep.svg';
import NetworkDrive from './svgs/network-drive.svg';
import SwitchHost from './svgs/switch-host.svg';
import SupportUser from './svgs/support-user.svg';
import KeyBlack from './svgs/key-black.svg';
import ErrorInfo from './svgs/error-info.svg';
import ErrorInfoComponent from './svgs/error-info.svg?component';
import EditMapping from './svgs/edit-mapping.svg';
import ScannIcon from './svgs/scan-icon.svg';
import PlayButton from './svgs/play-button.svg';
// import Delete from './pngs/delete.png';
// import Disconnect from './pngs/disconnect.png';
// import connect from './svgs/connect.svg';
// import DownloadOutlineIcon from './svgs/Download.svg';
import FacebookIconNew from './svgs/facebook-icon-new.svg';
import WhatsAppWithBackground from './svgs/WhatsApp-With-Background.svg';
import RedLockWithRedBackground from './svgs/Lock-With-Background-Red.svg';
import EnglishLanguageIcon from './svgs/english-language.svg';
import SentIcon from './svgs/sent-icon.svg';
import SeenIcon from './svgs/seen-icon.svg';
import Impression from './svgs/impression-icon.svg';
import EngagedIcon from './svgs/engaged-icon.svg';
import SubmittedOrder from './svgs/submitted-order.svg';
import AcceptedOrder from './svgs/accepted-order.svg';
import BilledOrder from './svgs/billed-order.svg';
import DispatchedOrder from './svgs/dispatched-order.svg';
import OrderIconBlack from './svgs/order-new.svg';
import ChatGrey from './svgs/chat-grey.svg';
import Move from './svgs/move.svg';
import alertIcon from './svgs/alertIcon.svg';
import ArrowRightGrey from './svgs/arrow-right-grey.svg';
import ArrowRightGreyNew from './svgs/arrow_right_grey_new.svg';
import ArrowRightBlack from './svgs/arrow-right-black.svg';
import WhatsappIcon from './svgs/whatsapp.svg';
import ErrorInfoIcon from './svgs/error-info.svg';
import MessageInputRight from './svgs/message-input-right-icon.svg';
import NewConversation from './svgs/new-conversation.svg';
import InProgressConversation from './svgs/in-progress-conversation.svg';
import ClosedConversation from './svgs/closed-conversation.svg';
import DragHandleBlack from './svgs/drag-handle-black.svg';
import UserFilledComponent from './svgs/user-filled.svg?component';
import ClockIconGrey from './svgs/clock-new-grey.svg';
import AddTeamMember from './svgs/add-team-members.svg';
import ClockIcon from './svgs/clock-icon.svg';
import RaisedByPerson from './svgs/raised-by-person.svg';
import AssignTeamMemberBtn from './svgs/assign-team-members.svg';
import TeamMembers from './svgs/team-members.svg';
import ComingSoon from './svgs/coming-soon.svg';
import Expired from './svgs/expired.svg';
import Active from './svgs/active.svg';
import PercentageIcon from './svgs/percentage.svg';
import LocationsIcon from './svgs/locations-icon.svg';
import CategoriesIcon from './svgs/Categories.svg';
import DivisionIcon from './pngs/divisions.png';
import CategoryIcon from './pngs/category.png';

import GroupByIcon from './svgs/group-by.svg';
import MoveLifecycleGroupGif from './gifs/move-lifecycle-group.gif';
import EmptyConversation from './pngs/empty-conversation.png';
import AutomaticGroupIcon from './svgs/automatic-group.svg';
import LocationPinCircle from './svgs/location-pin-circle.svg';
import RemoveMinusRedIcon from './svgs/remove-minus-red.svg';
import PriceTag from './svgs/price-tag.svg?component';
import EmptyState from './svgs/empty-state.svg';
import DeleteBucketLargeImage from './pngs/delete-bucket-large-icon.png';
import CalendarEdit from './pngs/calendar_edit.png';
import NoInternalNotesImage from './pngs/Nointernalnotes_img.png';
import AddGreenIcon from './svgs/add-green-icon.svg';
import SendGreenIcon from './svgs/send-green-icon.svg';
import ZoeyZoaiBlack from './svgs/zoey-zoai-black.svg';
import ZotokBotIcon from './svgs/zotok-icon.svg';
import CloseBlackOutlineCircle from './svgs/close-black-outline-circle.svg';
import TeamMemberOwner from './svgs/team-member-owner.svg';
import CloseCrossIconRed from './svgs/Close_Red_Icon.svg';
import ERPNext from './svgs/ERPNext.png';
import EmptySearchState from './svgs/empty-search-state.svg';
import SendIcon from './svgs/send-icon.svg';
import SendIconComponent from './svgs/send-icon.svg?component';
import ColorPalette from './svgs/color-palette.svg';
import WhiteTick from './svgs/white-tick.svg';
import WhiteTickComponent from './svgs/white-tick.svg?component';
import NotificationIcon from './svgs/notification-icon.svg';
import MessageResponseIcon from './svgs/message-resonse-icon.svg';
import SettingsIcon from './svgs/settings-icon-new.svg';
import SearchIconBlack from './svgs/search-icon-black.svg';
import PublishSendIconBlue from './svgs/publish-send-blue.svg';
import EmptyApiKeys from './pngs/empty-api-keys.png';
import CrossIconCircleBlue from './svgs/cross-icon-circle-blue.svg';
import ConnectIconWhite from './svgs/connect-white.svg';
import EditIconBlue from './svgs/edit-icon-blue.svg';
import StarIconNew from './svgs/star-icon-new.svg';
import profieIconSvg from './svgs/profileIcon.svg';
import PlusIconNew from './svgs/plus-icon-new.svg';
import MinusIconNew from './svgs/minus-icon-new.svg';
import DivisionsIcon from './svgs/divisions-icon.svg';
import FormIcon from './pngs/form-icon.png';
import SchemeDivisionsIcon from './pngs/scheme_division.png';

import AdSourceSquareIcon from './svgs/adsource-square-icon.svg';
import EventSquareIcon from './svgs/event-square-icon.svg';
import SegmentSquareIcon from './svgs/segement-square-icon.svg';
import StandardSquareIcon from './svgs/standard-square-icon.svg';
import PinComponent from './svgs/un-pinned.svg?component';
import BroadcastIcon from './svgs/broadcast-icon.svg';
import CoworkingIcon from './svgs/coworking-icon.svg';
import ListViewGrey from './svgs/list_view_grey.svg';
import FullScreen from './svgs/full-screen.svg';

import BookTextIcon from './svgs/book-text.svg';
import LayoutTemplateIcon from './svgs/layout-template.svg';
import PackageSearchIcon from './svgs/package-search.svg';
import htmlIcon from './svgs/htmlIcon.svg';
import customHtmlIcon from './svgs/custom-html.svg';
import codeIcon from './svgs/code.svg';
import TruckDispatch from './svgs/truck-dispatch.svg';
import TransporterNameIcon from './svgs/TransporterNameIcon.svg';
import PaymentReceiptOutline from './svgs/payment-outline.svg';
import DiscountTag from './svgs/discount-tag.svg';
import DiscountTagComp from './svgs/add_discount.svg?component';
import AddCustomerIcon from './svgs/add-customer-icon.svg';
import CircleMinusRedIcon from './svgs/circle-minus-red.svg';
import CircleMinusRedIconComponent from './svgs/circle-minus-red.svg?component';
import AddCircleBlackIcon from './svgs/add-circle-black.svg';
import RestApiIcon from './svgs/rest-api-icon.svg';
import InternalGroupIcon from './svgs/internal-group-icon.svg';
import ImportIcon from './svgs/import.svg';
import ExportIcon from './svgs/export.svg';
import MapFieldsIcon from './svgs/map.svg';
import CampaignBlackIcon from './svgs/campaign-black-icon.svg';
import SearchCustomerThread from './svgs/search-customer-thread.svg';
import SearchGroupIcon from './svgs/search-group-Icon.svg';
import customerThreadIcon from './svgs/customerThread.svg';
import searchThreadCUST from './svgs/search-thread-cust.svg';
import EditBlackIcon from './svgs/editPencilIconBlack.svg';
import CalendarNew from './pngs/calendar-new.png';
import SAP from './pngs/SAP_B1.png';
import ParsingLoaderLottie from './lotties/parsing-loader.json';
import KeyboardShortcut from './svgs/keyboard-shortcuts.svg';
import KeyboardShortcutIcon from './svgs/Keyboard.svg?component';
import InfoNewIcon from './svgs/InfoNewIcon.svg?component';
import CopyGrey from './svgs/copy-grey.svg';
import LibraryIcon from './svgs/library.svg';
import LibraryImagePreview from './pngs/library-image.png';
import CampaignLogoBlackIcon from './svgs/campaign-logo-black.svg';
import ReplaceBlueIcon from './svgs/replace-blue-icon.svg';
import SequenceChangeIconComponent from './svgs/sequence-change.svg?component';
import SequenceChangeIconNewComponent from './svgs/sequence-change-new.svg?component';
import UnavailableIcon from './svgs/unavailable-icon.svg';
import Unavailable from './pngs/unavailable.png';
import SaveIconWhite from './svgs/save-icon-white.svg';
import CalenderScheduleIcon from './svgs/calendar-schedule.svg?component';
import CampaignImpressionIcon from './svgs/campaign-view.svg';
import CampaignEngagementIcon from './svgs/campaign-engage.svg';
import ConfigIcon from './svgs/config-icon.svg';
import PriorityImage from './pngs/priority.png';
import NoQueriesImage from './pngs/no-queries-image.png';
import OcrScan from './svgs/ocr_scan.svg';
import MsgSeen from './svgs/msg-seen.svg';
import MsgDelivered from './svgs/msg-delivered.svg';
import FieldMatchedIcon from './svgs/field-matched-icon.svg';
import CfaIconNew from './svgs/CFAIconNew.svg';
import GoDownSIcon from './svgs/Godown.svg';
import configDynamicIcon from './svgs/config-dynamic.svg';
import configDownArrowIcon from './svgs/config-down-arrow.svg';
import configUpArrowIcon from './svgs/config-up-arrow.svg';
import WhatsappWhiteOutlined from './svgs/whatsapp-white-outlined.svg';
import ChatIconWhite from './svgs/chat-icon-white.svg';
import RupeeCoinEncircled from './svgs/rupee_encircled.svg';
import RupeeCoinEncircledBlue from './svgs/rupee_encircled_blue.svg';
import InvoiceBlue from './svgs/invoice_blue.svg';
import OrderBlue from './svgs/order_blue.svg';
import Warehouse from './svgs/warehouse.svg';
import ServiceUnits from './svgs/service-units.svg';

import CalendarEncircledBlue from './svgs/calendar-encircled-2.svg';
import CalendarEncircled from './svgs/calendar-encircled-1.svg';
import ClockEncircled from './svgs/clock-encircled.svg';
import WarningEncircled from './svgs/warning-encircled.svg';
import EmailYellow from './svgs/email-yellow.svg';
import InvoiceDetails from './svgs/invoice-details.svg';
import PlayWhite from './svgs/play-white.svg';
import StopWhite from './svgs/stop-white.svg';
import DonutChart from './svgs/donut-chart.svg';
import DonutChartWhite from './svgs/donut-chart-white.svg';
import Table from './svgs/table.svg';
import TableWhite from './svgs/table-white.svg';
import BarChart from './svgs/bar-chart.svg';
import PieChart from './svgs/pie-chart.svg';
import BarChartWhite from './svgs/bar-chart-white.svg';
import PieChartWhite from './svgs/pie-chart-white.svg';
import StorageBox from './svgs/storage-box.svg';
import ProductHero from './svgs/product-hero.svg';
import GoogleIconWhite from './svgs/google-icon-white.svg';
import DisConnectIcon from './svgs/disconnect-icon.svg';
import Bug from './svgs/bug.svg';
import Threads from './svgs/chat.svg';
import Customer from './svgs/customer.svg';

export const SHARED_LOTTIES = {
  FreeBadgeLottie,
  LoadingAnimationLottie,
  OfferDiscountLottie,
  TopUpFailureLottie,
  TopUpSuccessLottie,
  LoadingLottie,
  WelcomeSplashLottie,
  DocumentScannLottie,
  GrowSetupLoaderLottie,
  ParsingLoaderLottie,
};

export const SHARED_GIFS = {
  LoadingAnimationGif,
  MoveLifecycleGroupGif,
};

export const SHARED_PNGS = {
  SAP,
  BotImage,
  DefaultSize: DefaultSize,
  CampaignIcon: Campaign,
  ThreadsNoView: ThreadsNoView,
  SchemeDivisionsIcon,
  InvalidFile: InvalidFile,
  ImageUpload: ImageUpload,
  CheckoutPng: CheckoutPng,
  Delete: Delete,
  TallyIcon,
  DeleteSchemeIcon: DeleteSchemeIcon,
  cfaLocationIcon,
  NoSegmentChart,
  Disconnect: Disconnect,
  NoDataGraph: NoDataGraph,
  BankEmptyStateImage: BankEmptyStateImage,
  UpiEmptyStateImage: UpiEmptyStateImage,
  WhatsAppGrid: WhatsAppGrid,
  GrowDashboardInitViewBgImage: GrowDashboardInitViewBgImage,
  BankAvatar,
  QRAvatar,
  NoVisits,
  FileUploadImage,
  ERPNext,
  DivisionIcon,
  GoogleIcon,
  TemplateMangerBackground,
  LibraryImagePreview,
  CampaignDefaultTemplateVideo,
  CampaignDefaultTemplateVideoDefault,
  UploadOrder,
  InfoBlue3d,
  DiscountIconNew,
  FormIcon,
  FreeImage,
  PendingInvoice,
  BuildCustomer: BuildCustomerList,
  ManageCatalogue,
  SetupWABA: Whatsapp,
  PublishCampaign,
  ProductsEmpty,
  PriorityImage,
  ThankYou,
  NoInvoicesImage,
  NoCustomersImage,
  NoPaymentsImage,
  NoPriceListsImage,
  NoReturnsImage,
  NoSchemesImage,
  NoLedgersImage,
  NoProductsImage,
  NoCategoryImage,
  NoOrdersImage,
  NoDispatchImage,
  NoCustomFieldsImage,
  NoSearchResultsImage,
  NoFormsImage,
  MetaIcon,
  NoReportsImage,
  NoTeamMembers,
  NoWabaImage,
  NoPersonalWhatsapp,
  NoBotsImage,
  NoSyncImage,
  NoImportsImage,
  NoCfaImage,
  NoHeadDivisions,
  NoDivisionsImage,
  NoFilteredResults,
  NoChannelsImage,
  UploadBulkFile,
  NoBulkUploads,
  NoCategoriesImage,
  NoRoutesImage,
  NoSegmentsImage,
  NoCustomerThreads,
  NoIssueThreads,
  NoGroupThreads,
  NoCampaignsImage,
  NoCampaignRevenue,
  NoRevenueBreakdown,
  NoDownloadsImage,
  NoDynamicSegements,
  AssignTeamMemberEmpty,
  FailedImage,
  ZoaiAnalysis,
  ZohoDeleteIcon,
  NoLocationDimensions,
  NoChannelDimensions,
  NoProductDimensions,
  NoUnreadMessages,
  NoFeedsImage,
  FilterIconLarge,
  customersPng,
  locationPng,
  BusinessContact,
  AssignLocation,
  PersonalContact,
  NoRoutes,
  NoCustomers,
  DeleteFolder,
  AgentTasksPlaceholder,
  AgentKnowledge1,
  AgentKnowledge2,
  AgentKnowledge3,
  FacebookSystemAccessToken,
  WelcomeCup,
  WelcomeCard1,
  WelcomeLayer1,
  WelcomeLayer2,
  WelcomeScreenImage,
  AutomateBusinessImage,
  IntegrateFieldImage,
  LetAIHandleImage,
  SmartCampaignsImage,
  CaptureOrdersImage,
  ProductsTooltipImage,
  WelcomeScreenMask,
  DeleteFilesImage,
  PreviewFlowImage,
  ExcelView,
  ThumbnailView,
  ParentVariantView,
  GenerationFailedImage,
  PublishOnWhatsapp,
  PublishOnCtwa,
  WhatsappPhone,
  FacebookPhone,
  StatusBarIcons,
  ProfileIcon,
  MobileWhatsappBackground,
  EmptyProfile,
  FacebookLikes,
  FacebookIcons,
  WareHouse,
  Shop,
  StreetCoffeeStall,
  BusinessmanSolvingCustomrDoubts,
  CampaignImg,
  BotImg,
  InvoiceImg,
  PaymentImg,
  RupeeImg,
  CalendarImg,
  FreeImg,
  LegalDocuments,
  WabaSetupIcon,
  IndiaMartIcon,
  ZonoMoneySimulatorHeader,
  ZonoMoneySimulatorFooter,
  WabaSetupNudgeIcon,
  ShippingIcon,
  SFTPIcon,
  EmptyConversation,
  DeleteBucketLargeImage,
  WarningIconNew,
  NoInternalNotesImage,
  EmptyApiKeys,
  CalendarNew,
  Unavailable,
  NoQueriesImage,
  CalendarEdit,
  CategoryIcon,
};

export const SHARED_SVGS = {
  Bug,
  Threads,
  Customer,
  StorageBox,
  ProductHero,
  DonutChart,
  DonutChartWhite,
  Table,
  TableWhite,
  BarChart,
  BarChartWhite,
  PieChart,
  PieChartWhite,
  PlayWhite,
  StopWhite,
  FullScreen,
  InvoiceDetails,
  EmailYellow,
  Warehouse,
  ServiceUnits,
  CompareFiles,
  InvoiceBlue,
  OrderBlue,
  CalendarEncircled,
  CalendarEncircledBlue,
  ClockEncircled,
  WarningEncircled,
  RupeeCoinEncircled,
  RupeeCoinEncircledBlue,
  ChatIconWhite,
  AddCustomerIcon,
  ImportIcon,
  ExportIcon,
  MapFieldsIcon,
  RouteRigthIcon,
  UserIconWithArrows,
  ClickIcon: ClickIcon,
  ColumnIcon: ColumnIcon,
  DownloadFile: DownloadFile,
  PencilLargeWabaMaster: PencilLargeWabaMaster,
  DragHandle: DragHandleComp,
  CalenderScheduleIcon,
  CategoriesIcon,
  PercentageIcon,
  MsgSeen,
  MsgDelivered,
  Bysegments,
  Standard,
  NotificationIcon,
  MessageResponseIcon,
  SettingsIcon,
  SettingsBlue,
  MessageIcon,
  OnClickIcon,
  BotMoreIcon,
  CustomerCountIcon,
  ServiceIcon,
  BookOrderView,
  BookEnquiries,
  BulbIcon,
  Danger,
  Free,
  Offer,
  DoubleTick,
  GroupIcon,
  GroupByIcon,
  CampaignFilled: CampaignFilled,
  BulletDefault,
  BulletIcon,
  BeatPlanIcon: BeatPlanIcon,
  GroupsTabIcon,
  RoiIcon: RoiIcon,
  NotificationFilled: NotificationFilled,
  SharedGrey: SharedGrey,
  DownArrowBlue: DownArrowBlue,
  AddCircleUnfilled: AddCircleUnfilled,
  AddCircleIcon,
  GrowWhatsappCrmIcon,
  MarketingFunelIcon,
  SalesFunelIcon,
  ConversationsFunelIcon,
  PopupFunelLoadingIcon,
  PopupFunelSuccessIcon,
  SetupDefaultFunelIcon,
  SettingsFunnelIcon,
  DateIcon,
  DownloadHistory,
  ListView: ListView,
  ListViewGrey,
  offerIcon,
  ManualOfferIcon,
  FolderMinimise,
  FolderMaximize,
  TemplatePreviewBottom: TemplatePreviewBottom,
  ThreeDotIconComp: ThreeDotIconComp,
  SearchEnter: SearchEnter,
  PencilLarge: PencilLarge,
  GalleryView: GalleryView,
  CalendarIconComponent,
  ListViewNew,
  LocationsIcon,
  HomeComp,
  ManageCatalogueComp,
  SetupWABA,
  Task_Done,
  CheckComp,
  OnBoardingpopuptopIcon,
  GrowRevenuWhatsAppIcon,
  IncreaseGrowthIcon,
  ImproveCollectionPaymentIcon,
  AutomateCustomerResponseIcon,
  BuildCustomerListComp,
  CustomersTabIconComponent,
  ChecklistDrawerBackground,
  ChecklistCloseComp,
  RightArrowComp,
  CSVIcon,
  CloseRedIconRounded: CloseRedIconRounded,
  PlaceholderComp,
  ProductTabIcon,
  ChecklistCompletedComp,
  plusIconComponent,
  SearchNew: SearchNew,
  CampaignBlackComp: CampaignBlack,
  NoTemplates,
  NotificationThreadIcon,
  NotificationZoeyIcon,
  NotificationWAppSyncedIcon,
  NotificationTransactionIcon,
  ReplyComp: ReplyComp,
  ListViewComp: ListViewComp,
  ZoCoinIcon: ZoCoinIcon,
  ResendIcon: ResendIcon,
  ResendBlueIcon: ResendBlueIcon,
  flowBotIcon: flowBotIcon,
  ResetIcon: ResetIcon,
  Refresh: Refresh,
  ImgPlaceholder: ImgPlaceholder,
  PublishIcon: PublishIcon,
  ShareIcon: ShareIcon,
  ShareIconComp,
  WalletComp,
  ArrowRightWhite,
  copySvg,
  RedLockWithRedBackground,
  WhatsAppWithBackground,
  CloneIcon: CloneIcon,
  CloneIconComponent: CloneIconComponent,
  CloneWhiteIcon: CloneWhiteIcon,
  ErrorIconRed: ErrorIconRed,
  ErrorIconNew,
  Copy: Copy,
  DownloadHistoryIcon,
  ArrowLeftFC: ArrowLeftFC,
  ArrowLeftNew,
  DotmenuIcon,
  DotmenuActiveIcon,
  EnableIcon,
  DisableIcon,
  DocumentColor,
  DocIconComp: DocIconComp,
  DownloadComponent,
  CrossIconComponent,
  ConnectError,
  ConnectLoading,
  dynamicSegment,
  CustomersStatsIcon,
  SegmentsTabIcon,
  TemplateIconComponent,
  LineChartComponent,
  FacebookIconNew,
  CatalogueSync,
  MetaIcon: MetaIcon_,
  IndiaMartIconNew,
  ArrowPointer,
  KebabMenu: KebabMenu,
  KebabMenuNewIcon: KebabMenuNewIcon,
  KebabMenuComp,
  CampaignIcon: CampaignIcon,
  BackArrowLT: BackArrowLT,
  LeftArrowIcon: LeftArrowIcon,
  LocationIcon: LocationIcon,
  InvoiceDoc: InvoiceDoc,
  SuccessTick: SuccessTick,
  Navigation: Navigation,
  NavigationComp,
  PaymentCollect: PaymentCollect,
  LocationNotAvilable: LocationNotAvilable,
  Calender: Calender,
  ZotokPinRed: ZotokPinRed,
  ZotokPinGreen: ZotokPinGreen,
  ZotokPinPurple: ZotokPinPurple,
  OutlineWarning: OutlineWarning,
  ApprovalIcon: ApprovalIcon,
  WarningIconComponent: WarningIconComponent,
  LocationCheckIn: LocationCheckIn,
  OrderPlaced: OrderPlaced,
  TimelineClockInOut: TimelineClockInOut,
  TimelineLocation: TimelineLocation,
  ClockIn: ClockIn,
  offerIconStr,
  ClockOut: ClockOut,
  DownloadBlue: DownloadBlue,
  DownloadWhite: DownloadWhite,
  UploadIconBlue: UploadIconBlue,
  TickDoneCheck: TickDoneCheck,
  Pincode: Pincode,
  CityIcon: City,
  Truck: Truck,
  Steering: Steering,
  DriverIcon: DriverIcon,
  RejectCross: RejectCross,
  Weight: Weight,
  Assets: Assets,
  orderTagIcon: orderTagIcon,
  TagIcon: TagIcon,
  Download: Download,
  TrendingUp: TrendingUp,
  TrendingDown: TrendingDown,
  Plus: Plus,
  UpIcon: UpIcon,
  UpIconComponent: UpIconComponent,
  DownIcon: DownIcon,
  DownIconComponent: DownIconComponent,
  CalendarFaded: CalendarFaded,
  EditIcon: EditIcon,
  EditIconNew: EditIconNew,
  EditNewIconBlack: EditNewIconBlack,
  AddIconComponent: AddIconComponent,
  TrashIcon: TrashIcon,
  TrashIconNew: TrashIconNew,
  DeleteIconNew: DeleteIconNew,
  DeleteIconNewComp: DeleteIconNewComp,
  CalendarIcon: CalendarIcon,
  CalendarNewIcon: CalendarNewIcon,
  CalendarRoundCorners: CalendarRoundCorners,
  UncheckedBox: UncheckedBox,
  CheckedBox: CheckedBox,
  CheckBoxDisable: CheckBoxDisable,
  AddCircle,
  AddCircleComp,
  Warning: Warning,
  External_Link: External_Link,
  link_url: link_url,
  CustomColumns,
  CustomColumnsNew,
  Email,
  EmailIconNew,
  EmailBlack,
  CampaginSuccessSvg,
  superAdminUpdateIcon,
  superAdminRewindIcon,
  GridViewBlack,
  GridViewWhite,
  Sms,
  ThreadIcon,
  closeBlackIcon,
  connectIcon: connect,
  ConnectBlueIcon,
  CloseGrey: CloseGrey,
  CloudUpload: CloudUpload,
  CloudUploadBlue,
  CloudUploadIcon,
  EnglishLanguageIcon,
  VerificationSuccess: VerificationSuccess,
  PromotionPurple,
  PromotionPurplePath,
  AddButton,
  TickIcon,
  OcrScan,
  KebabMenuIcon,
  KebabMenuIconFC: KebabMenuIconFC,
  CrossIcon,
  CloseCrossIcon,
  CheckIconBlack,
  CheckIconBlue,
  CheckBoxGreenSVG,
  CheckBoxDefault,
  CheckBoxBlueSVG,
  CheckBoxBlack,
  EyeSvg,
  blackEyeSvg,
  EyeIconNew,
  ChechBoxGreySVG,
  CheckBoxZonoBlue,
  Neutral,
  DocIcon: DocIcon,
  UploadIcon: UploadIcon,
  DeleteIcon: DeleteIcon,
  DeleteWhiteIcon,
  SuspendAccessIcon: SuspendAccessIcon,
  FallbackIcon: FallbackIcon,
  MinusComponent,
  SmallDeleteIcon: SmallDeleteIcon,
  CreateIcon: CreateIcon,
  CrossIconCircleRedComponent,
  CrossIconCircleRed,
  CrossIconCircleBlue,
  SuccessTickIcon,
  WarningIcon,
  CloseIcon,
  CloseRedIcon,
  CloseBlueIcon,
  CloseWhiteIcon,
  CopyIcon,
  Verified,
  UploadFile,
  ZonoDigitalBgLogo: ZonoDigitalBgLogo,
  DTERP: DTERP,
  SearchProperty: SearchProperty,
  Bot: Bot,
  ViewDetailsIcon: ViewDetailsIcon,
  MoveChannelIcon: MoveChannelIcon,
  InviteLinkIcon: InviteLinkIcon,
  InviteLinkIconComponent,
  WarningSymbol,
  HoverActive,
  Default,
  DetailsGreen: DetailsGreen,
  Details: Details,
  CommsSearchIcon,
  IssuesTabIcon,
  GroupTabIcon,
  GroupTabIconComponent,
  CustomersTabIcon,
  LedgerListIcon,
  WhatsAppIcon,
  MobileGreyIcon,
  FormGreyIcon,
  FacebookGreyIcon,
  SortIcon,
  CrossIconGrey,
  TextColor,
  AlignCenter,
  AlignLeft,
  AlignRight,
  BoldText,
  ItalicText,
  UnderLineText,
  ListItemsIcon,
  IndentaionIcon,
  StrikeThrough,
  DocumentColour,
  DefaultColour,
  Popular,
  CloseIconOutline,
  PhotoIcon,
  PhotoIconNew,
  Resize,
  WhatsApp,
  Instagram,
  Youtube,
  Facebook,
  Camera,
  BusinessCard,
  Document,
  DocumentGreyIcon,
  Star,
  Message,
  Media,
  Order,
  CampaignNewIcon,
  FinanaceNewIcon,
  OrderComp,
  Invoice,
  Payment,
  Minus,
  AddMember,
  UserCheckIcon,
  Info,
  InfoIconButton: InfoIconButton,
  InputInfo,
  InputInfoError,
  AlgorithmIcon,
  AlgorithmIconComponent,
  Spinner,
  LockIconNew,
  UnLockIconNew,
  MapIconNew,
  InvoiceNewIcon,
  OrderNewIcon,
  OrderIconNew,
  PaymentIconNew,
  InvoiceIconNew,
  MediaIconNew,
  MapIcon,
  LockNewIcon,
  UnLockNewIcon,
  InviteIcon,
  ReInviteIcon,
  InviteSentIcon,
  ClockBlackIcon,
  EventsIcon,
  WhatsAppDisableIcon,
  WhatsAppIconComponent,
  ArrowRight,
  ArrowLeft,
  LeftArrow,
  LeftArrowNew,
  RightArrowNew,
  ArrowUp,
  BlueArrowDown,
  ArrowDown,
  AdminIcon,
  MemberIcon,
  MemberIconComponent,
  OrderManagerIcon,
  OrderOperatorIcon,
  CatalogueManagerIcon,
  FinanceManagerIcon,
  CRMUserIcon,
  SelectArrowDown,
  SelectArrowUp,
  ZotokCircle,
  ZotokLogo,
  DiscountIcon,
  PlusIcon,
  FilterNew,
  ZoaiIcon,
  NoSearchResults,
  DivisionsIcon,
  AssignTeamMemberIcon: AssignTeamMember,
  AssignTeamMember_: AssignTeamMember_,
  InfoIcon,
  InfoGrey,
  IrrelevantIcon,
  KebabMenuIcon2,
  kebabMenuBlueIcon,
  kebabMenuBlueNewIcon,
  AcceptTick,
  searchIcon,
  searchIconComponent,
  InvoiceIcon,
  OrderIcon,
  detailsBlue,
  otherInfoBlue,
  Location,
  LocationNewIcon,
  CfaLocationNewIcon,
  PhoneIcon,
  UserIcon,
  UserNewIcon,
  UserBlackIcon,
  PhoneBlackIcon,
  LockIcon,
  UploadFileIcon,
  MinusIcon,
  IconPlus,
  IconPlusComponent,
  CloseBlueRound,
  CloseCross,
  ReturnIcon,
  ZotokIcon,
  New: New,
  offer: offer,
  Special: Special,
  Folder: Folder,
  NoProducts,
  DownloadIcon,
  DocumentIcon,
  ScheduleIcon,
  iconInfo,
  InfoIconBlue,
  SchedulerIcon,
  AddCircleBlueOutlinedComp,
  DeactivateIcon,
  ExecuteIcon,
  Notification,
  NotificationNewIcon,
  CartNewIcon,
  MertricsIcon,
  KPIIcon,
  PinnedIcon,
  UnPinnedIcon,
  TrendingUpIcon,
  TrendingDownIcon,
  ComboView,
  ChartIcon,
  ConfigSetting,
  ErrorIcon,
  Click,
  OrderIcon_,
  OrderIconComponent,
  RightBlack,
  RightGrey,
  RightBlue,
  RightArrowBlack,
  ArrowRightBlue,
  Roi,
  ViewIcon,
  ProductIcon,
  CustomersIcon,
  CaretDownIconNew,
  CaretRightIconNew,
  AddCustomersIcon,
  GraphIcon,
  PlusOutline,
  PlusOutineWhite,
  InfoNew,
  InfoIconBlack,
  MuteNewIcon,
  AgentLeadsIcon,
  AgentLeadsActiveIcon,
  TeamMemberLeadIcon,
  TeamMemberLeadActiveIcon,
  MessageWaitMinutesIcon,
  InfoIconComponent,
  RightIcon,
  DefaultProduct,
  NoResults,
  DownArrow,
  DownArrowComp,
  UpArrowComp,
  SelectArrowDownComp,
  SelectArrowUpComp,
  ArrowUpNew,
  ArrowUpIcon,
  RefreshIconCampaign,
  MiscTagForCustomer,
  NeutralGrey,
  Image,
  Loader,
  CampaignDefaultImg,
  DefaultPicture,
  TimeIcon,
  ArrowLeftIcon,
  View,
  PlusIconBlack,
  CaretDownIcon,
  CaretRightIcon,
  CloseRed,
  ArrowDownDark,
  ArrowDownBlue,
  CampaignDefaultTemplate,
  CampaignDefaultTemplateDoc,
  CampaignDefaultTemplateLocation,
  ProductDefaultTemplate,
  DefaultCheckboxNew,
  SearchIconNew,
  NoDivisionsIcon,
  CheckedCheckboxNew,
  NeutralCheckboxNew,
  NonSelectIcon,
  Rupee,
  FileNew,
  FileUpload,
  FileUploadNewIcon,
  FileUploadComponent: FileUploadComponent,
  FileUploadBlue,
  Right,
  VectorIcon,
  ToggleOpen,
  ToggleClose,
  TagBlackIcon: tagBlackIcon,
  WabaIcon: wabaIcon,
  LeftDown: leftDown,
  TagWhiteIcon: tagWhiteIcon,
  SendArrowBlack: SendArrowBlack,
  SendArrowComponent: SendArrowComponent,
  upgradeIcon,
  compairIcon,
  CloseFilled,
  BankIcon,
  DropdownClose,
  DropdownOpen,
  BankAccount,
  Upi,
  zoeyIcon,
  ZoeyIconComponent: ZoeyIconComponent,
  whiteCloseIcon,
  CheckWhiteIcon,
  PriceList,
  MinusIconBlack,
  UploadBlueIcon,
  AddIcon,
  AddBlueIcon,
  AddBlueNewIcon: AddBlueNewIcon,
  MinusBlueNewIcon: MinusBlueNewIcon,
  ReminderIcon,
  ReminderIconNew,
  languageIcon,
  UploadFileBlack,
  RefreshIcon: ResendIcon,
  PaperPinBlack,
  FilterIcon,
  CloseIconNew,
  CloseIconNewComp,
  UploadWhiteIcon,
  ParseFileIcon,
  ImageIcon,
  Seen,
  Deliverd,
  DeliverdIconNew,
  Sent,
  SentIconNew,
  SeenIconNew,
  StartIcon,
  StarIconNew,
  SettingsBlack,
  SettingsIconComponent,
  ExternalBlack,
  ExternalBlackComp,
  SearchIcon,
  EnterIcon,
  DiscountOfferSVG,
  FreeOfferSVG,
  BulkUploadSuccess,
  HourGlass,
  RadioSelected,
  InactiveRadio,
  RadioUnselected,
  AppsAndConsent,
  Synchronize,
  DownloadWhiteIcon,
  ZotokAppsLogo,
  ZoTokApiLogo,
  TallyLogo,
  ExternalLinkBlueIcon,
  SuccessTickMedium: SuccessTick,
  FieldTypeCheckboxIconComponent,
  FieldTypeDateIconComponent,
  FieldTypeTimeIconComponent,
  FieldTypeDropdownIconComponent,
  FieldTypeTextIconComponent,
  FieldTypeNumberIconComponent,
  FieldTypeTimeIcon,
  UploadIconFillBlue,
  DeactivateIconRed,
  ShopifyIcon,
  RazorpayIcon,
  InfobipIcon,
  SecuresmscIcon,
  GoogleSheetIcon,
  GoogleIconWhite,
  OoduIcon,
  RefreshIconNew,
  ArrowDownWhite,
  ExternalLinkWhite,
  GenerateKey,
  ConnectIcon,
  CloseIconSmall,
  ToggleOff,
  ToggleOnActive,
  ToggleOffDeActive,
  ViewEye,
  ViewEyeNew,
  EyeIconBlue,
  CloseIconSmallGrey,
  Filter,
  CustomersIconNew,
  CustomersIconNewComp,
  RefreshIconBlue,
  RefreshIconGrey,
  AllCfa,
  AllCustomers,
  FolderClosed,
  TickDoneCheckGreen,
  FolderIcon,
  PdfIcon,
  GreenCheckIcon,
  DeleteNewIcon: DeleteNewIconComponent,
  BulbWithSettings,
  AvatarNew,
  RedCircleOutlined,
  GreenSquareOutlined,
  GreenDiamondFill,
  YellowCircleFill,
  BlueTriangleFill,
  ChatIcon,
  BotIcon,
  BotLibrary,
  PieIcon,
  AddCircleWhite,
  WhatsAppIconOutlined,
  WhatsAppDisabledIconOutlined,
  FacebookWhiteIcon,
  WhatsappBlackIcon,
  WhatsappWhiteIcon,
  LeftArrowBlack,
  VideoCallIcon,
  AudioCallIcon,
  BackBlueIcon,
  StickersBlueIcon,
  AddMediaIcon,
  SendBlueIcon,
  OutlineWarningIcon,
  CampaignFacebook,
  CampaignGraphView,
  CampaignGraphHide,
  CampaignGraphShowIcon,
  CampaignGraphShowHoverIcon,
  CampaignGraphHideIcon,
  CampaignGraphHideHoverIcon,
  WebsiteEmail,
  Chat,
  Esacalate,
  AgentOrderIcon,
  AgentOutstandingIcon,
  AgentLedgerIcon,
  AgentKnowledgeIcon,
  AgentInvoiceIcon,
  AgentCatalogIcon,
  AgentPaymentIcon,
  AgentAccountIcon,
  AgentQueryIcon,
  AgentWelcomeIcon,
  Ledger,
  FolderGrey,
  Rename,
  WorkFlow,
  WorkFlowComponent,
  OrderAgent: Order_,
  Parse,
  PaymentAgent: Payment_,
  Product,
  Search,
  InvoicePDF,
  DeduplicationSetupIcon,
  EditIconBlack,
  ZoomIn,
  ZoomOut,
  SynchronizeBlue,
  MappingArrow,
  KnowledgeAgent,
  AiIcon,
  Manual,
  Automatic,
  AutomaticComponent,
  FunnelIcon,
  LoyalCustomersIcon,
  LoyalCustomersIconNew,
  InfrequentCustomersIcon,
  InfrequentCustomersIconNew,
  DormantCustomersIconNew,
  PotentialCustomersIcon,
  PotentialCustomersIconNew,
  NudgeCustomersIconNew,
  MeaningfulConversationsIconNew,
  TargetCampaignsIcon,
  TargetCampaignsIconNew,
  PersonalizeCatalogueIconNew,
  ExploreCatalogueIconNew,
  SpecificOffersIconNew,
  CatalogExperienceIcon,
  CatalogExperienceIconNew,
  OrderFormatIconNew,
  AiDrivenRepliesIcon,
  AutoSendInvoicesIcon,
  AutoSendLedgersIcon,
  BoostSalesReachIcon,
  ManageEnquiriesicon,
  CTWAAdsIcon,
  EnhanceLoyaltyIcon,
  AnalyzeGrowthIcon,
  WhatsAppOrderingIcon,
  EditIconWhite,
  AddCircleBlueOutlined,
  VerificationSuccessIcon,
  RotateAntiClockWhite,
  InfoFillIconComponent,
  InfoFillWhiteIconComponent,
  GenerateKeyBlue,
  FileZillIcon,
  PlayButton,
  WinSEPIcon,
  NetworkDrive,
  SwitchHost,
  SupportUser,
  KeyBlack,
  PublishOnWhatsappNew,
  PublishOnCtwaNew,
  ErrorInfo,
  ErrorInfoComponent,
  EditMapping,
  ScannIcon,
  OrderIconBlack,
  SentIcon,
  SeenIcon,
  Impression,
  EngagedIcon,
  SubmittedOrder,
  AcceptedOrder,
  BilledOrder,
  DispatchedOrder,
  ChatGrey,
  WhatsappOutlinedIcon,
  NotifyCustomersIcon,
  Move,
  alertIcon,
  ArrowRightGrey,
  ArrowRightGreyNew,
  ArrowRightBlack,
  WhatsappIcon,
  ErrorInfoIcon,
  MessageInputRight,
  NewConversation,
  InProgressConversation,
  DisConnectIcon,
  ClosedConversation,
  DragHandleBlack,
  UserFilledComponent,
  ClockIconGrey,
  AddTeamMember,
  ClockIcon,
  RaisedByPerson,
  AssignTeamMemberBtn,
  TeamMembers,
  ComingSoon,
  Expired,
  Active,
  AutomaticGroupIcon,
  LocationPinCircle,
  RemoveMinusRedIcon,
  PriceTag,
  HomeLocation,
  EmptyState,
  AddGreenIcon,
  SendGreenIcon,
  ZoeyZoaiBlack,
  ZotokBotIcon,
  CloseBlackOutlineCircle,
  TeamMemberOwner,
  CloseCrossIconRed,
  EmptySearchState,
  SendIcon,
  SendIconComponent,
  ColorPalette,
  WhiteTick,
  WhiteTickComponent,
  SearchIconBlack,
  PublishSendIconBlue,
  ConnectIconWhite,
  EditIconBlue,
  AdSourceSquareIcon,
  EventSquareIcon,
  SegmentSquareIcon,
  StandardSquareIcon,
  PinComponent,
  BroadcastIcon,
  CoworkingIcon,
  PackageSearchIcon,
  LayoutTemplateIcon,
  BookTextIcon,
  htmlIcon,
  codeIcon,
  TruckDispatch,
  TransporterNameIcon,
  PaymentReceiptOutline,
  customHtmlIcon,
  DiscountTag,
  DiscountTagComp,
  CircleMinusRedIcon,
  CircleMinusRedIconComponent,
  AddCircleBlackIcon,
  RestApiIcon,
  InternalGroupIcon,
  CampaignBlackIcon,
  UserIconDynamic,
  SearchCustomerThread,
  SearchGroupIcon,
  customerThreadIcon,
  searchThreadCUST,
  EditBlackIcon,
  profieIconSvg,
  PlusIconNew,
  MinusIconNew,
  KeyboardShortcut,
  KeyboardShortcutIcon,
  InfoNewIcon,
  CopyGrey,
  LibraryIcon,
  CampaignLogoBlackIcon,
  ReplaceBlueIcon,
  SequenceChangeIconComponent,
  SequenceChangeIconNewComponent,
  UnavailableIcon,
  SaveIconWhite,
  CampaignImpressionIcon,
  CampaignEngagementIcon,
  ConfigIcon,
  SubtractSign,
  PlusSign,
  EqualSign,
  FieldMatchedIcon,
  CfaIconNew,
  GoDownSIcon,
  configDownArrowIcon,
  configUpArrowIcon,
  configDynamicIcon,
  WhatsappWhiteOutlined,
};

export * from './svgs/sidebar-icons';
